/**
 * Permalink to a booking's PDF. The route regenerates the PDF if the booking
 * changed and redirects to a freshly signed storage URL on every hit, so the
 * link itself never expires.
 */
export function bookingPdfUrl(uuid: string): string {
  return new URL(
    `/bookings/${uuid}/pdf`,
    import.meta.env.VITE_API_URL,
  ).toString();
}
